import { render, staticRenderFns } from "./MyMoveFile.vue?vue&type=template&id=da8a9f86"
import script from "./MyMoveFile.vue?vue&type=script&lang=js"
export * from "./MyMoveFile.vue?vue&type=script&lang=js"
import style0 from "./MyMoveFile.vue?vue&type=style&index=0&id=da8a9f86&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports